import { render } from "./FavoritesTeachers.vue?vue&type=template&id=7299cf79&scoped=true"
import script from "./FavoritesTeachers.vue?vue&type=script&lang=js"
export * from "./FavoritesTeachers.vue?vue&type=script&lang=js"

import "./FavoritesTeachers.vue?vue&type=style&index=0&id=7299cf79&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7299cf79"]])

export default __exports__